// Video Player Constants
import { BRIGHTCOVE_BASE_URL } from './param-constants';

export const OOYALA_CLASS = "ooyala-player-Gundry-MD";

export const VIDEO_SCRIPTS = [
  "//player.ooyala.com/static/v4/stable/4.24.9/core.min.js",
  "//player.ooyala.com/static/v4/stable/4.24.9/video-plugin/main_html5.min.js",
  "//player.ooyala.com/static/v4/stable/4.24.9/skin-plugin/html5-skin.min.js"];
export const VIDEO_STYLE_REL = "stylesheet";
export const VIDEO_STYLE_HREF = "//player.ooyala.com/static/v4/stable/4.24.9/skin-plugin/html5-skin.min.css";

export const fbParam = ".fbParam {\n\tdisplay: initial !important;;\n}";
export const tbaParam = ".tbaParam {\n\tdisplay: initial !important;;\n}";
export const obParam = ".obParam {\n\tdisplay: initial !important;;\n}";
export const msnParam = ".msnParam {\n\tdisplay: initial !important;;\n}";
export const revParam = ".revParam {\n\tdisplay: initial !important;;\n}";

export const BRIGHTCOVE_SCRIPTS = [
  `${BRIGHTCOVE_BASE_URL}/default_default/index.min.js`];
